// ============================================================================
// SECURITY SERVICES - Barrel Export
// ============================================================================
// All security-related services for cheat detection and prevention.
// Import from this file for clean access to all security services.
// ============================================================================

// Import all services
import securityFlagServiceInstance from './securityFlagService';
import deviceFingerprintServiceInstance from './deviceFingerprintService';
import collusionDetectionServiceInstance from './collusionDetectionService';
import botDetectionServiceInstance from './botDetectionService';
import chipDumpingServiceInstance from './chipDumpingService';
import riskScoreServiceInstance from './riskScoreService';

// Re-export as named exports
export const securityFlagService = securityFlagServiceInstance;
export const deviceFingerprintService = deviceFingerprintServiceInstance;
export const collusionDetectionService = collusionDetectionServiceInstance;
export const botDetectionService = botDetectionServiceInstance;
export const chipDumpingService = chipDumpingServiceInstance;
export const riskScoreService = riskScoreServiceInstance;

// Re-export types from securityTypes for convenience
export * from '../../types/securityTypes';